.container {
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  gap: 1.5rem;
}

.field {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.checkboxGroup {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  height: 100%;
}
